/**
 * Whether the current viewer may persist shared project state (PROJECT_GLOBAL, ORGANIZATION
 * properties). Read-only viewers (guests below EDIT, share-link visitors) keep their local changes
 * in memory only; the server would refuse the write, and a refused write is noise at best.
 *
 * Module-level rather than React context on purpose: the property service that persists writes
 * is a single global instance owned by whichever hook initialised it first, which may sit outside
 * the project page. The project page sets this flag from its access level.
 */
let canPersist = true;

export const setProjectWriteAccess = (allowed: boolean): void => {
  canPersist = allowed;
};

export const canPersistProjectWrites = (): boolean => canPersist;
